import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts/core';
import {
    TitleComponent,
    TooltipComponent,
    GridComponent,
    LegendComponent
} from 'echarts/components';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    LegendComponent,
    BarChart,
    CanvasRenderer
]);

export default function MainChart({ monthly_counts }) {
    const chartRef = useRef(null);

    useEffect(() => {
        const chartInstance = echarts.init(chartRef.current);

        const months = monthly_counts.map(item => item.month_name.slice(0, 3)); // Jan, Feb, etc.

        const purchase = monthly_counts.map(item => item.purchase_count);
        const sale = monthly_counts.map(item => item.sale_count);
        const empSale = monthly_counts.map(item => item.employee_sale_count);
        const purchaseReturn = monthly_counts.map(item => item.purchase_return_count);
        const saleReturn = monthly_counts.map(item => item.sale_return_count);
        const orders = monthly_counts.map(item => item.order_count);

        const option = {
            title: {
                text: 'Business Performance Overview',
                subtext: 'Monthly analytics and metrics',
                left: 'left',
                textStyle: {
                    fontSize: 18,
                    fontWeight: 'bold'
                }
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                data: ['Purchase', 'Sale', 'Employee Sale', 'Purchase Return', 'Sale Return', 'Orders'],
                top: 40,
                right: 20
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true,
                top: 100
            },
            xAxis: {
                type: 'category',
                data: months,
                axisLabel: {
                    color: '#6c757d',
                    fontWeight: 500
                },
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                }
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    color: '#6c757d'
                },
                splitLine: {
                    lineStyle: {
                        color: '#e9ecef'
                    }
                }
            },
            series: [
                {
                    name: 'Purchase',
                    type: 'bar',
                    barGap: 0,
                    itemStyle: { color: '#3b82f6' },
                    emphasis: { focus: 'series' },
                    data: purchase
                },
                {
                    name: 'Sale',
                    type: 'bar',
                    itemStyle: { color: '#22c55e' },
                    emphasis: { focus: 'series' },
                    data: sale
                },
                {
                    name: 'Employee Sale',
                    type: 'bar',
                    itemStyle: { color: '#eab308' },
                    emphasis: { focus: 'series' },
                    data: empSale
                },
                {
                    name: 'Purchase Return',
                    type: 'bar',
                    itemStyle: { color: '#ef4444' },
                    emphasis: { focus: 'series' },
                    data: purchaseReturn
                },
                {
                    name: 'Sale Return',
                    type: 'bar',
                    itemStyle: { color: '#ec4899' },
                    emphasis: { focus: 'series' },
                    data: saleReturn
                },
                {
                    name: 'Orders',
                    type: 'bar',
                    itemStyle: { color: '#a855f7' },
                    emphasis: { focus: 'series' },
                    data: orders
                }
            ]
        };

        chartInstance.setOption(option);

        const handleResize = () => {
            chartInstance.resize();
        };
        window.addEventListener('resize', handleResize);

        return () => {
            chartInstance.dispose();
            window.removeEventListener('resize', handleResize);
        };
    }, [monthly_counts]); // 👈 ensure chart updates on prop change

    return (
        <div className="card p-2">
            <div className="" style={{ height: '400px' }}>
                <div ref={chartRef} style={{ width: '100%', height: '100%' }}></div>
            </div>
        </div>
    );
}
